import api from '../axiosConfig';

const API_URL = '/api/colors'; 

export const fetchColors = () => api.get(API_URL);
export const createColor = (data) => api.post(API_URL, data);
export const updateColor = (id, data) => api.put(`${API_URL}/${id}`, data);
export const deleteColor = (id) => api.delete(`${API_URL}/${id}`);
